module.exports = __webpack_public_path__ + "Roboto-ThinItalic.34490796413a7cc266ac.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/assets/font/roboto/Roboto-ThinItalic.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-ThinItalic.woff
// module chunks = 2